import React from "react";
import HomeImage from "../image/3-spiderman-pointing-meme-template-c5n1w-removebg-preview (1).png";

const ContactUsPage = () => {
  return (
    <div
      className="text-center mt-2 sm:mt-5 md:mt-10 lg:text-3xl xl:h-screen flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-5
      min-h-screen
    "
    >
      {" "}
      <div className="flex flex-col items-center justify-center gap-3">
        <h1>اتصل بنا</h1>
        <p>للتواصل معنا يمكنكم استخدام البريد الإلكتروني التالي:</p>
        <p>alihatem7201738@gmail.com</p>
      </div>
      <div className="">
        <img
          src={HomeImage}
          className="object-cover h-full max-w-2xl sm:max-w-4xl w-full"
          alt="hero"
        />
      </div>
    </div>
  );
};

export default ContactUsPage;
